<template>
  <nav
    class="navbar navbar-expand-lg navbar-light" :class="{'ct-navbar-website' : website}"
  >
    <template v-if="website">
      <div class="burger-container d-none d-md-flex" @click.prevent="toggleSidebarMini">
        <i class="svg-icon svgi-lg" :class="[sidebarMini ? 'svgi-menu-burger' : 'svgi-menu-burger-open']"></i>
      </div>
      <div class="burger-container d-flex d-md-none" @click.prevent="toggleSidebarMobile">
        <i class="svg-icon svgi-lg" :class="[sidebarMobile ? 'svgi-menu-burger-open' : 'svgi-menu-burger']"></i>
      </div>
    </template>
    <div class="navbar-brand" :class="{'ml-3' : website}">
      <router-link class="navbar-brand" :to="{ name: 'Home', params: {} }">
        <img
          src="/static/images/logo/website-builder-with-name.svg"
          width="140"
          class="d-none d-md-inline-block"
          v-if="getUser() && getUser().user_domain"
          alt="Logo Website Builder"
        />
        <img
          src="/static/images/logo/cheetah-with-name-new.png"
          width="140"
          class="d-none d-md-inline-block"
          alt="Logo Cheetah"
          v-else
        />
        <img
          src="/static/images/logo/cheetah-new.png"
          width="32px"
          class="d-inline-block d-md-none"
          alt="Logo Cheetah"
        />
      </router-link>
      <div class="changelogfy-widget"></div>
    </div>

    <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
      <router-link data-ba-i="create-website"  :to="{ name: 'CreateWebsite', query: { step: 'template'}}" class="btn btn-primary btn-nav mr-0" v-show="newSite"><i
        class="svg-icon svgi-add-page"></i>{{ $t('ct-create-website')}}
      </router-link>
      <button data-ba-i="create-page" class="btn btn-primary btn-nav" v-show="website" @click.prevent="newPage()"><i class="svg-icon svgi-add-page"></i>
        <span style="white-space: nowrap">{{ $t('ct-page-create')}}</span>
      </button>
      <button data-ba-i="publish-website"  class="btn btn-success btn-nav publish-button mr-0" v-if="showPublish" @click.prevent="publish">
        <i class="svg-icon svgi-publish-button"></i>{{ $t('ct-publish')}}
      </button>
      <button data-ba-i="unpublish-website" class="btn btn-danger btn-nav" v-show="showUnpublish" @click.prevent="unpublish()"><i
        class="svg-icon svgi-unpublish-button"></i>{{ $t('ct-unpublish')}}
      </button>
      <button data-ba-i="republish-website"   class="btn btn-success btn-nav publish-button mr-0" v-if="showUnpublish" :disabled="!showRepublish" @click.prevent="republishAction()"><i
        class="svg-icon svgi-publish-button"></i>{{ $t('ct-republish')}}
      </button>
    </div>
    <div class="vrow mx-3 d-none d-lg-block" style="height: 25px"></div>
    <div class="dropdown user-dropdown-menu d-block my-2 ml-auto my-lg-0 mr-3">
      <router-link 
        :to="{name:`${isHome ? 'UserSettings' : 'Home'}`}"
      >
          <i 
            :class="`svg-icon svgi-lg svgi-${isHome ? 'gear-page' : 'home-back'}`"
            v-tooltip="{
              content: $t(`ct-${isHome ? 'general-settings' : 'back-home'}`), 
              class: 'ba-tooltip-custom'
            }"
          />
      </router-link>
      <!-- <button
        class="btn btn-settings dropdown-toggle dropdown-navbar-principal"
        type="button"
        id="dropdownMenuButton"
        aria-haspopup="true"
        aria-expanded="false"
      >{{ getName() }}</button>
      <div class="dropdown-menu user-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <div class="dropdown-arrow"></div>
        <router-link :to="{ name: 'UserSettings'}"
                     class="dropdown-item"
                     href="#">
          <div class="abrev">{{ getName() }}</div>
          <div class="user-info">
            <span class="w-100 d-block name">{{ getUser().name }}</span>
            <span class="w-100 d-block email">{{ getUser().email }}</span>
          </div>
        </router-link>
        <div class="dropdown-divider"></div>
        <div class="dropdown-item-language-selector d-block" style='max-width: 100%'>
            <span class="dropdown-item px-2">
              <i class="svg-icon svgi-language"></i>
              {{ $t('ct-prefered-language')}}
            </span>

          <div class="dropdown">
            <button class="dropdown-toggle nano-toggle language-selector-btn d-flex justify-content-between" type="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
              <div>
                <img :src="'/static/images/icons/flags/' + getUser().lang  + '.svg'" v-if="getUser().lang">
                <img :src="'/static/images/icons/flags/'+getDefaultLang()+ '.svg'" v-else>
                <template v-for="(lang, index) in this.languages">
                  <span v-if="getUser().lang === lang.descricao || (!getUser().lang && getDefaultLang() === lang.descricao)">{{ lang.label_desc }}</span>
                </template>
              </div>
              <font-awesome-icon :icon="['fas', 'sort']" class="font-awesome-icon sort-icon"/>

            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <div class="language-selector-header">
                <span class="w-100 title">{{ $t('ct-prefered-language')}}</span>
                <div class="input-group mt-2">
                    <span class="input-group-prepend bg-white border-right-0">
                        <span class="input-group-text bg-transparent">
                            <i class="mdi mdi-magnify"></i>
                        </span>
                    </span>
                  <input class="form-control border-left-0" :placeholder="$t('ct-search-language')"
                         v-model="languageSearch">
                </div>
              </div>
              <div class="nano">
                <div class="nano-content">
                  <a v-for="(lang, index) in this.filteredLanguages" v-bind:key="index" class="language-item"
                     :class="getUser().lang == lang.descricao ? 'active' : ''" href="#"
                     @click.prevent="changeLang(lang.descricao)"><img
                    :src="'/static/images/icons/flags/' + lang.descricao + '.svg'">{{ lang.label_desc }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <router-link
          :to="{ name: 'UserSettings'}"
          class="dropdown-item"
          href="#">
          <i class="svg-icon svgi-gear"></i>
          {{ $t('ct-settings')}}
        </router-link>
        <a class="dropdown-item" href="#" @click.prevent="logout">
          <i class="svg-icon svgi-logout"></i>
          {{ $t('ct-logout')}}
        </a>
      </div> -->
    </div>

    <sweet-modal ref="publishConfirm" width="25%" hide-close-button blocking>
      <div>{{ $t('ct-publish-confirm')}}</div>
      <button
        slot="button"
        class="btn btn-outline-primary mt-2"
        @click.prevent="cancelModal('publishConfirm')"
      >{{ $t('ct-ok')}}
      </button>
    </sweet-modal>

<!--    <page-component ref="page"></page-component>-->
  </nav>
</template>

<script>
import NavItemComponent from './NavItem.vue';
import {logout} from './../../../../js/services/editor/login';
import {mapGetters} from 'vuex';
import {getLanguages} from '../../../../js/services/translate';
import {SweetModal} from 'sweet-modal-vue';
import {
  publish as PublishWebsiteRequest,
  publishWithoutDomain as publishWithoutDomainRequest, updateVersion
} from './../../../../js/services/editor/publish';
import {
  exclude as excludeWebsite,
  updateStatus,
  duplicateWebsite
} from './../../../../js/services/editor/website';

import {getUser, update as updateUser} from './../../../../js/services/user';
import PageComponent from '../../pages/Page.vue';

export default {
  name: 'NavComponent',
  components: {
    NavItemComponent,
    SweetModal,
    PageComponent
  },
  props: [
    'items', 'align', 'active', 'website',
    'newSite', 'newSiteModal', 'showPublish', 'showUnpublish',
    'sidebarMini', 'sidebarMobile', 'showRepublish'
  ],

  data() {
    return {
      languages: [],
      languageSearch: ''
    };
  },

  methods: {
    ...mapGetters({getUser: 'user', getLangs: 'getLanguages'}),

    getDefaultLang() {
      return (window.getCookie('languageEditorUser') != null) ? window.getCookie('languageEditorUser') : 'en_US';
    },

    newPage() {
      if (this.$route.name !== 'SitePageCreate') {
        this.$router.push({name: 'SitePageCreate', params: {layout_id: this.website.layouts[0].encrypted_id}});
      }
    },

    getName() {
      let name = '';
      if (this.$store.state.user.name) {
        name = String(this.$store.state.user.name);
      }
      return name.substring(0, 2);
    },

    changeLang(lang) {
      this.languageSearch = '';
      this.updateUser(lang);
    },

    updateUser(lang) {
      this.$loading.show();
      let user = this.getUser();
      user.lang = lang;
      updateUser(user)
        .then(response => {
          this.$loading.hide();
          this.user = response.data.data;
          this.$store.dispatch('updateUser', response.data.data);
          localStorage.setItem('username', response.data.data.name);
          localStorage.setItem('supercheckout_lang', this.user.lang);

          this.$translate.setLang(this.user.lang);
          this.$translate.init(this.user.lang);
          this.$snotify.success('Success update user');
        })
        .catch(error => {
          if (error.response) {
            this.errors.record({user: error.response.data.errors});
          }
          console.warn(error);
        });
    },

    getWebsiteEncryptedIdCurrent() {
      if (this.$route.name === 'SitePages' && !!this.$route.params.id) {
        return this.$route.params.id;
      }
      return false;
    },

    republishAction() {
      this.$emit('republish');
    },

    publish() {
      this.$emit('publish');
    },

    publishWithoutDomain() {
      if (this.getWebsiteEncryptedIdCurrent()) {
        publishWithoutDomainRequest(this.getWebsiteEncryptedIdCurrent())
          .then(res => {
            this.$refs.publishConfirm.open();
            this.updateStatus({
              encrypted_id: this.getWebsiteEncryptedIdCurrent(),
              status: 'active'
            });
          })
          .catch(error => {
            this.$snotify.error(
              this.$t(
                'ct-publish-error',
                'Something happened when trying to publish your site, check the settings'
              )
            );
          });
      }
    },

    unpublish(status = 'inactive') {
      let data = {
        encrypted_id: this.$parent.website.encrypted_id,
        status: status
      };

      this.updateStatus(data);
    },

    updateStatus(data) {
      updateStatus(data)
        .then(res => {
          this.$emit('changeStatusPublish', data.status);
        })
        .catch(error => {
          console.error(error);
          this.$snotify.error(
            'Something happened when trying to unpublish or publish your site, check the settings'
          );
        });
    },

    showNewSiteModal() {
      if (this.newSiteModal) {
        this.$parent.newSite.showModal = true;
      } else {
        this.$router.push({name: 'Dashboard', params: {openNewSiteModal: true}});
      }
    },

    logout() {
      logout()
        .then(data => {
          let response = data.data;

          if (response.success) {
            window.token = response.token;

            localStorage.setItem('login', false);
            localStorage.removeItem('username');
            localStorage.removeItem('token');

            this.$store.dispatch('updateUser', {});

            if(['sitebuilder.kub.app.builderall.io', 'sitebuilder.kub.app.builderall.info'].includes(window.location.hostname) || process.env.NODE_ENV === 'development')
              this.$router.push('/login');
            else
              window.open('https://office.builderall.com/','_self');
          } else {
            this.errors = {};
            this.errors.message = response.error;
          }
        })
        .catch(error => {
          console.warn(error);
        });
    },

    cancelModal(type) {
      if (this.$refs[type]) {
        this.$refs[type].close();
        return;
      }
      this.modal[type].show = false;
      this.modal[type].config = '';
    },

    toggleSidebarMini() {
      this.$emit('toggleSidebarMini');
    },

    toggleSidebarMobile() {
      this.$emit('toggleSidebarMobile');
    }
  },
  computed: {
    isHome() {
      return !!(this.$route.name === 'Dashboard' || this.$route.name === 'Home')
    },
    filteredLanguages() {
      if (this.languageSearch !== '') {
        return this.languages.filter(item => {
          return item.label_desc.toLowerCase().indexOf(this.languageSearch.toLowerCase()) > -1;
        });
      }
      return this.languages;
    },
    getWebsite() {
      return this.$parent.website;
    }
  },
  mounted() {
    this.languages = this.getLangs();

    if (!this.languages) {
      getLanguages()
        .then(data => {
          this.languages = data.data;

          let languages = this.languages;
          let vm = this;
          this.$store.commit('languages', this.languages);
          vm.languages = Object.assign({}, vm.languages, languages);
        })
        .catch(error => {
          console.warn(error);
        });
    }

    $('.user-dropdown-menu #dropdownMenuButton').on('click', function(event) {
      $('.user-menu').toggleClass('show');
    });

    $('body').on('click', function(e) {
      if (!$('.user-dropdown-menu #dropdownMenuButton').is(e.target) &&
          $('.user-menu').has(e.target).length === 0 &&
          $('.show').has(e.target).length === 0
      ) {
        $('.user-menu').removeClass('show');
      }
    });

    setTimeout(() => {
      if ($('#changelogfy_badge').text() === '') { $('#changelogfy_badge').text('!').css({'display': 'block'}) }
    }, 10000);
  }
};
/*
var script = document.createElement('script');
// This script has a callback function that will run when the script has
// finished loading.
script.src = 'https://widget.changelogfy.com/index.js';
script.type = 'text/javascript';
document.getElementsByTagName('head')[0].appendChild(script);
*/
</script>

<style lang="scss" scoped>

  .changelogfy-widget {
    position: absolute;
    right: 20px;
    top: 5px;

    #changelogfy_badge {
      display: block;
    }
  }

  .navbar {
    width: 100%;
    height: 60px;

    top: 0;
    left: 0;
    z-index: 1;

    background: #FFFFFF;

    -ms-flex-flow: row nowrap;
    flex-flow: row nowrap;
    -ms-flex-pack: start;
    justify-content: flex-start;


    &.ct-navbar-website{
      padding: 0;
      margin: 0;
    }

    &-brand {
      display: flex;
      align-items: center;
      position: relative;

      &-info {
        margin-left: 10px;

        h1 {
          font-weight: bold;
          font-size: 20px;
          font-family: Muli;

          letter-spacing: 3.4px;
          line-height: 1;
          color: #0080FC;

          margin: 0;
        }

        p {
          font-size: 13px;
          font-weight: bold;
          font-family: Muli;
          color: #434343;

          opacity: 0.45;
          margin: 0;
        }

        @media (max-width: 1200px) {
          display: none;
        }
      }
    }

    .burger-container {
      width: 66px;
      height: 62px;

      display: flex;
      align-items: center;
      justify-content: center;

      /*border-right: 2px solid #efefef;*/
      cursor: pointer;
      background: #f4f4f4b3;
      border-right: 1px solid #dededeb3;
      transition: .2s;

      i{
        width: 29px;
      }
    }
  }

  .dropdown-toggle {
    padding: 0;
  }

  .dropdown-toggle::after {
    display: none;
  }

  .title-obj, .title-word {
    font-size: 20px;
    font-weight: normal;
  }

  .title-obj, .title-word-xs {
    font-size: 12px;
    font-weight: bold;
  }

  .title-obj {
    font-size: 23px;
    font-weight: lighter;
    color: #000;
  }

  .title-word, .title-word-xs {
    color: #0080FC;
    margin: 0;
    padding: 0;
  }

  .btn-settings {
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    background-color: #0080FC;
    color: #FFF;
  }

  .abrev {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    font-size: 15px;
    text-align: center;
    line-height: 58px;
    text-transform: uppercase;
    background-color: #0080FC;
    color: #FFF;
  }

  .dropdown-navbar-principal {
    text-transform: uppercase;
  }

  .dropdown-menu-right {
    left: auto;
    right: 0;
  }

  .user-dropdown-menu {
    font-weight: lighter;
    padding-top: 6px;
  }

  .user-menu, .user-menu .dropdown-item {
    color: #434343;
    font-weight: lighter;
  }

  .user-menu::before {
    content: "";
    position: absolute;
    right: 10px;
    top: -10px;
    width: 10;
    height: 10;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-color: transparent transparent #fff transparent;
    z-index: 9999;
  }

  .user-info {
    padding-left: 10px;

    .name {
      font-size: 18px;
    }

    .email {
      font-size: 13px;

    }
  }

  .btn-nav {
    margin-right: 15px;
    height: 40px;
    text-transform: uppercase;
  }

  .dropdown-item-language-selector {
    padding: 0 15px;

    .language-selector-btn {
      background-color: #F2F2F2;
      border: 0;
      border-radius: 3px;
      padding: 7.5px;
      margin: 15px 0;
      width: 100%;
      text-align: left;

      img {
        height: 30px;
        margin-right: 15px;
      }

      .font-awesome-icon {
        margin-top: 2px;
        color: #ADADAD;
        float: right;
      }
    }

    .dropdown-menu {
      padding: 0;
      background-color: #FCF7F7;
      box-shadow: 0 3px 5px #00000029;
      border-radius: 3px;
      margin-top: -100px;
      width: 100%;
      height: 290px;

      .language-selector-header {
        padding: 15px 15px 7.5px 15px;
      }

      span.title {
        font-size: 15px;
      }

      .form-control, .input-group-text, .form-control:focus {
        box-shadow: none;
        border-color: #E0E0E0;
        padding-left: 0;
      }

      .input-group-text {
        padding: 0 7.5px;
        text-align: center;

        .mdi {
          font-size: 20px;
        }
      }

      .nano-content, .nano {
        height: 185px;
      }

      .language-item {
        display: flex;
        width: 100%;
        align-items: center;
        padding: 15px;
        text-decoration: none;
        color: #434343;

        &.active {
          border-right: 5px solid #0080FC;
        }

        &:hover {
          background-color: #EDEDED;
        }

        img {
          height: 26px;
          margin-right: 12px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/nav/Nav.vue